<template>
  <div>
    <div id="div_BuscarPreload" v-if="!oProcesoEnCurso" class="clsdivPreload">
      <v-text-field id="input_PrecargarInfo" class="ma-0 pa-0"
          dense outlined hide-details 
          v-model="sLlave"
          :label="placeholderBusqueda"
          append-icon="mdi-magnify"
          @click:append="PreCargarInfo"
        />
    </div>
    <FormularioDinamico
      id="¨Frm_NuevoProceso" 
      :key="nKeyFormDinamic"
      :idFormulario="nIdFormulario" 
      :showButtons="false" 
      :initialFormFields="oInfoTransicones"
      @CargaCompleta="__CargaCompleta"
    >
      <template #Botones="{ formData, isValid, prepareData, processing, oLocation }">
        <v-row no-gutters justify="center" align="center" class="mb-10 mt-n8">
          <v-col v-for="(transicion, index) in atransiciones" :key="index" cols="10" class="text-center ma-1">
            <v-btn :id="`btn_AceptarSlot_${transicion}`" @click="procesar(transicion, formData, isValid, prepareData,oLocation)" large block dark color="btncolor" class="btn-primary btn-rounded" :loading="processing">
              {{ transicion.replace(/_/g, ' ').toUpperCase() }} <v-icon size="20" right>mdi-cogs</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="10" class="text-center ma-1 pt-8" >
            <v-btn id="btn_CancelarSlot" @click="confirmarCancelar" large block dark color="error" class="btn-primary btn-rounded">
              Cancelar <v-icon size="20" right>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </FormularioDinamico>
  </div>
</template>

<script>
import FormularioDinamico from '@/components/dinamicos/FormularioDinamico.vue';
import axiosServices from '@/services/axiosServices.js'
import HoraFecha from "@/utils/Hora_Fecha.js";


import { mapGetters } from 'vuex';

const HTTS_Response = [200, 201];

export default {
  name: 'DiligenciarFD',
  components: {
    FormularioDinamico,
  },
  props : {
    nIdFormulario_props : {
      type: Number,
      default: 0
    },
    sTransicion_props : {
      type: String,
      default: null
    },
    oProcesoEnCurso : {
      type: Object,
      default: () => {}
    }, 
  },
  data () {
    return { 
      nIdFormulario : 0,
      atransiciones : [],
      oInfoTransicones : [],
      aFotos: [],
      sLlave : "",
      placeholderBusqueda : "Buscar - Precargar Información",
      nKeyFormDinamic: 0,
    }
  },
  async mounted() {
    if (this.$route.name === 'ProcesoNewForm') {
      history.pushState(null, null, location.href);
      this._preventBack = () => {
        if (!window.__workflowGoingBack) {
          history.pushState(null, null, location.href);
        }
        window.__workflowGoingBack = false;
      };
      window.addEventListener('popstate', this._preventBack);
      this.$store.dispatch('setbNavegacion', true);
      this.$store.dispatch('setNavegacionBack', 'ProcesoDetalle');
    }

    this.nIdFormulario = parseInt(this.$route.params.idFormulario, 10)|| this.nIdFormulario_props;

    this.$store.dispatch('saveModalCargandoMo', true);
    

    if (!this.sTransicion_props){
      // se pide el detalle de transiciones con su metadata
      const oResponse = await axiosServices.getConfiguration(`workflow/${this.$route.params.idProceso}/transiciones/${this.getEstadoInicial}`, true);
      if(oResponse.nStatusCode === 200 ){
        this.atransiciones = oResponse.aData;
      }
      this.$store.dispatch('saveModalCargandoMo', false);

    }  else {
      // se trabaja un proceso en curso
      // me llego transicion predefinida cuando se carga el FDP en curso
      // la preload siempre debe ser en base al proceso en curso o actual -- OJO para el yml --
      const oResponse = await axiosServices.getConfiguration(`workflow/${this.$route.params.idProceso}/transiciones_detalle/${this.oProcesoEnCurso.sEstadoProceso}`, true, `sLlave=${this.oProcesoEnCurso.sLlave}`);
      if(oResponse.nStatusCode === 200 ){
        // this.atransiciones = oResponse.aData.aTransiciones;
        this.atransiciones = [this.sTransicion_props];
        this.oInfoTransicones = oResponse.aData.aInfoTransiciones;
        if(Object.keys(this.oInfoTransicones).length > 0 ) {
          this.nKeyFormDinamic++
          this.$store.dispatch('saveModalCargandoMo', true);
        }
      }

    }

    
  },
  beforeDestroy() {
    if (this._preventBack) {
      window.removeEventListener('popstate', this._preventBack);
      this.$store.dispatch('setbNavegacion', false);
      this.$store.dispatch('setNavegacionBack', '');
    }
  },
  computed: {
    ...mapGetters(['getimei', 'getisAPP', 'getnIduser', 'getsNombreUsuario']),
    ...mapGetters('str_Procesos',['getLlaveProceso', 'getEstadoInicial', 'getPrimeraTransition', 'getaInfoProceso', 'getoVariablesGlobales_Filter', 'getFiltrosGlobales']),
  },
  methods: {
    async procesar(sTransicion, formData, isValid, prepareData, oLocation) {

      if (!(await isValid())) {
        return;
      }

      
      // Filtramos el array para quitar elementos vacios (null, undefined) que no han sido llenados
      const formDataFiltrado = formData.filter(Boolean);
      
      const { aData, aFotos } = prepareData(formDataFiltrado);
      this.aFotos = aFotos;
      const dataCruda = aData;

      const isKeyAvailable = !!this.__LlaveExiste(dataCruda) || !!this.oProcesoEnCurso;

      if (isKeyAvailable) {
        const oBody = this.__PreparardataEnvio(dataCruda, sTransicion, oLocation);
        await this.__registrarProceso(oBody);
      } else {
        this.$store.dispatch("notificaciones/SetMensaje", "El Formulario no cuenta con la llave del proceso. Informar al administrador");
        this.$store.dispatch("notificaciones/ShowNotificacion", true);
      }
    },

    async __registrarProceso(oBody) {
      const oResponse = await axiosServices.postConfiguration(
        `/workflow/${this.$route.params.idProceso}/registrar`,
        oBody,
        true,
        `imei=${this.getimei}&app=PWA`
      );

      this.aFotos.forEach(async (foto) => {
        if ("NombreFoto" in foto) {
          axiosServices.postFoto(`${foto.NombreFoto}`, foto.Base64);
        }
        if ("Firma" in foto) {
          axiosServices.postFoto(`${foto.Firma}`, foto.Base64);
        }
      });

      if (HTTS_Response.includes(oResponse.nStatusCode)) {
        this.$swal({
          timer: 3000,
          icon:  `${oResponse.sStatus}`,
          title: `${oResponse.sMessage}`,
          text: `${oResponse.sMessage}`,
          showConfirmButton: true,
        });
        this.cancelar();
      }
    },

    async confirmarCancelar() {
      const result = await this.$swal({
        icon: 'warning',
        title: '¿Confirmación?',
        text: 'Se cancelará el diligenciamiento del formulario. Quiere Salir?',
        showConfirmButton: true,
        confirmButtonText: 'Sí',
        showCancelButton: true,
        cancelButtonText: 'No',
      });
      if (result.isConfirmed) {
        this.cancelar();
      }
    },

    cancelar() {
      this.$router.replace({
        name: 'ProcesoDetalle',
        params: {
          idProceso: this.$route.params.idProceso,
          NombreProceso: this.$route.params.NombreProceso
        },
      })
    },

    __LlaveExiste(aInfoValidar = []) {
      return aInfoValidar.find(campo => campo?.Titulo.trim() === this.getLlaveProceso.trim())
    },

    __PreparardataEnvio(aInfoCruda, sTransicion, oLocation) {
       if (!aInfoCruda) return {}
       
       const aux_sEstadoInicial = !this.oProcesoEnCurso ? this.getEstadoInicial : this.oProcesoEnCurso.sEstadoProceso;
       const aux_sTransicion =  !this.oProcesoEnCurso ? sTransicion : this.sTransicion_props;

       const nIdProceso = parseInt(this.$route.params.idProceso, 10);
       const oInfoProceso = this.getaInfoProceso;
       
       const oBody = {
         sLlave: !this.oProcesoEnCurso ? this.__LlaveExiste(aInfoCruda)?.TextoRespuesta : this.oProcesoEnCurso.sLlave,
         sEstadoInicial: aux_sEstadoInicial,
         sTransicion: aux_sTransicion,
         aDataHistoria: {
           idFormulario: this.nIdFormulario,
           idUsuario: this.getnIduser,
           sEstadoInicial: aux_sEstadoInicial,
           sTransicion: aux_sTransicion,
           sNombreUsuario: this.getsNombreUsuario,
           Latitud: oLocation.coords.latitude,
           Longitud: oLocation.coords.longitude,
           Fecha: HoraFecha.getNow(),
           infoForm: [...aInfoCruda]
         }
       };

      if (oInfoProceso && oInfoProceso.constGlobales) {
        const oVariablesGlobales = this.getoVariablesGlobales_Filter(nIdProceso);
        if (Object.keys(oVariablesGlobales).length > 0) {
          oBody.oVariablesGlobales = this.__getFiltroGlobales(oVariablesGlobales);
          oBody.aDataHistoria = {...oBody.aDataHistoria, oVariablesGlobales : {...oVariablesGlobales}} 
        }
      } 

      return oBody;
    },
    
    __getFiltroGlobales (oVariablesGlobales) {

      const filtrosNormalizados = new Set(this.getFiltrosGlobales.map(filtros => filtros.toLowerCase()));

      return Object.fromEntries(
        Object.entries(oVariablesGlobales).filter(([clave]) =>
          filtrosNormalizados.has(clave.toLowerCase())
        )
      );
    },

    async PreCargarInfo () {
      // se emplea para prearcar ingormarcion en el formulario cuando se va a iniciar un proceso
      this.$store.dispatch('saveModalCargandoMo', true);

      if (!this.sLlave) {
        this.$swal({
          timer: 1500,
          icon: 'error',
          title: "Debe escribir información",
          showConfirmButton: false,
        });
        this.$store.dispatch('saveModalCargandoMo', false);
        return
      } 

      const oResponse = await axiosServices.getConfiguration(`workflow/${this.$route.params.idProceso}/transiciones_detalle/${this.getEstadoInicial}`, true, `sLlave=${this.sLlave}`);
      switch (oResponse.nStatusCode) {
        case 200:
            if (oResponse.aData?.aInfoTransiciones?.length === 0  ) {
              this.$swal({
                timer: 2000,
                icon: 'info',
                title: "No se cuenta con información en el ultimo registro",
                showConfirmButton: false,
              });
            } else {
              this.oInfoTransicones = oResponse.aData.aInfoTransiciones;
              this.atransiciones = oResponse.aData.aTransiciones;
              if(Object.keys(this.oInfoTransicones).length > 0 ) { 
                this.nKeyFormDinamic++
                this.$store.dispatch('saveModalCargandoMo', true);
              }  
            }
        break;
        case 223:
          this.$swal({
            timer: 2000,
            icon: 'info',
            title: oResponse.aData.sMensaje,
            text: 'Realice otra busqueda',
            showConfirmButton: false,
          }); 
          this.atransiciones = []; 
          this.oInfoTransicones = []; // boro si habia data
          this.nKeyFormDinamic++

          break;
        default:
          break;
      }



    },

    __CargaCompleta () {
      // solo requiero para el cargador 
      if (this.$store.state.oModalCargandoMo && this.atransiciones?.length > 0) {     
        setTimeout(() => {
          this.$store.dispatch('saveModalCargandoMo', false);
      }, 1000); // 1 segundo para que se muestre bien el numero
      } 

    },
  }, // fin metodos
}
</script>

<style lang="scss" scoped>
 .clsdivPreload {
    margin-top: 10px;
    margin-bottom: -15px;
    padding-inline: 11px;
  }
 

</style>